(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('EditOrderBagServiceItemComponentController', EditOrderBagServiceItemComponentController);

    function EditOrderBagServiceItemComponentController($rootScope, $scope, $state, $stateParams, PersonInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, OrderBagServiceItemCustom, entity, $uibModalInstance) {
        //

        var $ctrl = this;
        $ctrl.loadPage = loadPage;
        $ctrl.loadAll = loadAll;
        if (entity)
            $ctrl.orderBagItem = entity.orderBagItem;
        $ctrl.errorMsg = "";
        $ctrl.successMsg = "";
        $ctrl.mode = 'DEFAULT'
        $ctrl.onItemChanged = onItemChanged;
        // $ctrl.orderBagItem = {};
        $ctrl.save = save;
        $ctrl.cancel = cancel;
        $ctrl.editableOrderBagItem = {};


        $ctrl.closeModal = closeModal;
        $ctrl.okModal = okModal;


        loadAll();
        loadPage();

        function loadAll() {
            if ($ctrl.orderBagItem) {
                $ctrl.editableOrderBagItem = angular.copy($ctrl.orderBagItem);

            }

            // if($ctrl.orderBagItemId )
            // {
            //     OrderBagServiceItemCustom.getOrderBagServiceItemWithEntities($ctrl.orderBagItemId).query().$promise.then(function (result) {
            //
            //         if(result)
            //         {
            //             $ctrl.orderBagItem = result;
            //         }
            //     })
            // }
        }


        function loadPage() {
            translatePartialLoader.addPart('personInfo');
            translatePartialLoader.addPart('locationInfo');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();
        }


        function onItemChanged(item) {

        }

        function save() {
            if ($ctrl.editableOrderBagItem.id) {
                OrderBagServiceItemCustom.editOrderBagServiceItem().save($ctrl.editableOrderBagItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:orderBagServiceItemUpdate', result);

            $ctrl.isSaving = false;
            $uibModalInstance.close(result);

        }

        function onSaveError() {
            $ctrl.isSaving = false;

        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }


        function closeModal() {
            cancel();

        }

        function okModal() {
            save();
        }

    }

    var EditOrderBagServiceItemComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/edit-order-bag-service-item/partial-form.edit-order-bag-service-item.html',
        controller: EditOrderBagServiceItemComponentController,
        bindings:
            {
                orderBagItem: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfEditOrderBagServiceItem', EditOrderBagServiceItemComponent)

    EditOrderBagServiceItemComponentController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'PersonInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'OrderBagServiceItemCustom', 'entity', '$uibModalInstance'];


})();

